import { createApi } from '@reduxjs/toolkit/query/react';
import { ScreenRecordDto, ScreenRecordResponseDto } from 'types';

import { configuration } from 'utils';
import axiosBaseQuery from 'utils/base-api';

export const screenRecorderApi = createApi({
  reducerPath: 'screenRecorderApi',
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    toggleRecord: builder.mutation<ScreenRecordResponseDto, ScreenRecordDto>({
      query: (screenRecordDto) => ({
        url: `${configuration.REACT_APP_SCREEN_RECORDING_CONNECTION_URL}api/Record`,
        method: 'post',
        data: screenRecordDto,
      })
    }),
  })
});

export const {
  useToggleRecordMutation,
} = screenRecorderApi;
